import { forwardRef, type PropsWithChildren } from "react";

import { cn } from "$/lib/utils/functions/misc.functions";

import { Option1 } from "./Options/Option1";
import { Option2 } from "./Options/Option2";
import type { TimePickerProps } from "./TimePicker.types";

const TimePicker = forwardRef<
  HTMLDivElement,
  PropsWithChildren<TimePickerProps>
>(({ style = "style_1", ...timePickerProps }, forwardedRef) => {
  return (
    <div
      ref={forwardedRef}
      className={cn(
        "flex items-center justify-center gap-4 text-black transition-all duration-200",
      )}
    >
      {style === "style_1" ? (
        <Option1 {...timePickerProps} />
      ) : (
        <Option2 {...timePickerProps} />
      )}
    </div>
  );
});

TimePicker.displayName = "TimePicker";

export default TimePicker;
